import React from 'react';
import classnames from 'classnames';
import { OptionList } from '../..';
import { keys } from '../../../utilities';
import { focusLastOption, focusFirstOption, getPreviousOption, getNextOption, } from '../../AnvilSelect/utils';
const TimePickerOptions = ({ className, options, onChange, focusValue, }) => {
    const handleKeyDown = (e, option) => {
        const { key } = e;
        const handledKeys = new Set([keys.enter, keys.down, keys.up]);
        if (handledKeys.has(e.key)) {
            e.preventDefault();
        }
        if (key === keys.down) {
            const nextOption = getNextOption(e.currentTarget);
            if (!nextOption) {
                focusFirstOption(e.currentTarget);
            }
            else {
                nextOption.focus();
            }
            return;
        }
        if (key === keys.up) {
            const previousOption = getPreviousOption(e.currentTarget);
            if (!previousOption) {
                focusLastOption(e.currentTarget);
            }
            else {
                previousOption.focus();
            }
            return;
        }
        if (e.key === keys.enter) {
            onChange(option.value);
        }
    };
    return (options.length > 0 && (React.createElement(OptionList, { className: classnames('m-1', className), focusValue: focusValue, options: options, onChange: onChange, optionOnKeyDown: handleKeyDown })));
};
export const TimePickerOptionList = React.memo(TimePickerOptions);
//# sourceMappingURL=TimePickerOptionList.js.map